<nav class="toolbar navbar navbar-light">
    <div class="form-inline">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
        <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" type="button" class="btn btn-outline-success" (click)="enviarAnulacion()"><i class="fa fa-save"></i> Guardar</button>
        <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Guardando
        </button>
    </div>
</nav>

<form [formGroup]="form" autocomplete="off">
    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">Anulación {{refAtestFito}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <!--<img class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitudAtestFito}}" />
                <label class="codigo2-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitudAtestFito}}">{{codigoTipoSolicitud}}</label>-->
                <img class="estado-icono-big" container="body" src="{{IdTipoSolicitudAtestFito | IconoTipoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitudAtestFito}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitudAtestFito | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloEstadoSolicitudAtestFito}}" />
            </span>
        </h5>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-accent-success animated fadeIn">
                    <div class="card-header"></div>
                    <div class="card-body-detalle">
                        <div class="row">
                            <!--<div class="form-group col-md-9">
                                <label class="col-form-label" for="inpDescripcion">Anulada por</label>
                                <input readonly formControlName="NombreUsuario" name="NombreUsuario" title="" class="form-control" id="inpUsuario" inputStyleClass="form-control" type="text" value="">
                            </div>-->
                            <!--Tipo CA-->
                            <div *ngIf="codigoTipoSolicitud === 'CA'" class="form-group col-md-9">
                                <label class="col-form-label" for="">Nombre Técnico Responsable</label>
                                <input readonly formControlName="NombreTecResponsable" name="NombreTecResponsable" title="" class="form-control" id="inpNombre" type="text" value="" maxlength="150">

                            </div>
                            <!--Tipo AC-->
                            <div *ngIf="codigoTipoSolicitud === 'AC'" class="form-group col-md-9">
                                <label class="col-form-label" for="">Agente de Control</label>
                                <input readonly formControlName="NombreAgenteControl" name="NombreAgenteControl" title="" class="form-control" id="inpNombre" type="text" value="" maxlength="150">
                            </div>
                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpFecha">Fecha</label>
                                <p-calendar formControlName="FechaAnulacion" inputStyleClass="form-control"
                                            [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                            </div>
                        </div>
                        <div class="row" style="margin-bottom:15px;">
                            <div class="form-group col-md-12">
                                <label class="col-form-label required-field" for="inpCodigo">Observaciones</label>
                                <textarea style="resize:none" formControlName="Observaciones" maxlength="500" name="Observaciones" title=""
                                          [ngClass]="displayFieldCss('Observaciones')"
                                          inputStyleClass="form-control" type="text" class="form-control" value=""></textarea>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Observaciones','required')">
                                    Observaciones es obligatorio
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
